// Cliente da API. Uma funcao so, para o envelope ser tratado num lugar.
import type { Resposta } from '@medicov1/shared';

const BASE = import.meta.env.VITE_API_URL ?? '/api';

export class ErroApi extends Error {
  constructor(public statusCode: number, public codigo: string, mensagem: string) {
    super(mensagem);
  }
}

export async function chamar<T>(
  caminho: string,
  opcoes: { metodo?: string; corpo?: unknown } = {},
): Promise<T> {
  const resposta = await fetch(`${BASE}${caminho}`, {
    method: opcoes.metodo ?? 'GET',
    headers: opcoes.corpo ? { 'content-type': 'application/json' } : undefined,
    body: opcoes.corpo ? JSON.stringify(opcoes.corpo) : undefined,
    credentials: 'include', // cookie httpOnly da sessao
  });

  // 204: deu certo e não há corpo (apagar, desfazer). Não é "sem resposta".
  if (resposta.status === 204) return undefined as T;

  const json = (await resposta.json().catch(() => null)) as Resposta<T> | null;

  if (!resposta.ok || !json) {
    const erro = json && 'error' in json ? json : null;
    throw new ErroApi(
      resposta.status,
      erro?.error ?? 'erro_desconhecido',
      erro?.message ?? 'Nao consegui falar com o servidor.',
    );
  }

  return (json as { data: T }).data;
}
